import style from "./LeaderboardUser.module.css";

// import balance_icon from '/balance-icon.png'

import tether_green from "/tether-green.png";

export default function LeaderboardUser(props) {
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "?";
  };

  return (
    <div
      className={`${style["container"]} ${
        props.borderbottom && style["borderbottom"]
      } ${props.bordertop && style["bordertop"]}`}
    >
      <div className={style["user-info"]}>
        <div
          className={
            props.finished ? style["position-finished"] : style["position"]
          }
        >
          {props.position}
        </div>
        {props.img ? (
          <img
            onLoad={() => {
              let obj = {};
              obj[props.referrerName] = true;
            }}
            className={style["avatar"]}
            src={props.img}
          ></img>
        ) : (
          <div className={style["avatar-fallback"]}>
            {getInitial(props.name)}
          </div>
        )}
        <div
          className={`${style["user-name"]} ${
            props.defaultcolor && style["defaultcolor"]
          } ${props.yourcolor && style["yourcolor"]}`}
        >
          {props.name}
        </div>
      </div>
      <div className={style["reward-container"]}>
        {props.usdt ? (
          <>
            <img className={style["coin-icon"]} src={tether_green} />
            <div className={`${style["reward"]}`}>{`${props.reward} USDT`}</div>
          </>
        ) : (
          <div className={`${style["reward"]} ${style["reward-leader"]}`}>
            {Math.floor(props.reward)} DC
          </div>
        )}
      </div>
    </div>
  );
}
